export default "__VITE_ASSET__BPEf6q14__"